<template>
  <form class="hidden-form" target="debug_window" method="POST" :action="url">
    <input
      v-for="(field, index) in allFormFields"
      :key="'field_' + index"
      type="hidden"
      :name="field.name"
      :value="field.value"
    />

    <button
      class="v-btn post-form"
      type="submit"
      :aria-label="ariaLabelText || text"
      :aria-describedby="spanId"
      :class="buttonClass"
      :disabled="disabled || !url"
    >
      <i v-if="icon" class="fa" :class="icon" />

      <span v-if="text" :id="spanId" role="info">{{ text }}</span>
    </button>
  </form>
</template>

<script>
import { SessionStorage } from '@witkac/kartamiejska-shared';

// @vuese
// Przycisk-formularz
export default {
  props: {
    // Url do wysłania formularza
    url: {
      type: String,
      required: false
    },

    // Pola formularza w formacie:
    // { name: string, value?: any }
    fields: {
      type: Array,
      required: false,
      default: () => []
    },

    // Tekst przycisku do wysłania formularza
    text: {
      type: String,
      required: false
    },

    // Klasa przycisku
    buttonClass: {
      type: String,
      required: false,
      default: 'v-btn--large theme--light'
    },

    // ikona przycisku
    icon: {
      type: String,
      required: false
    },

    // Przycisk zablokowany
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    // Tekst aria-label
    ariaLabelText: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      spanId: 'span_' + Math.floor(Math.random() * 10000)
    };
  },
  computed: {
    allFormFields() {
      return [
        ...this.fields.map(field => ({
          ...field,
          value: typeof field.value === 'object' ? JSON.stringify(field.value) : field.value
        })),
        { name: 'jwt', value: localStorage.getItem(SessionStorage.TOKEN) }
      ];
    }
  }
};
</script>

<style>
.hidden-form {
  display: inline-block;
}

.hidden-form input {
  display: none;
}
</style>
